module.exports = __webpack_public_path__ + "img/blog_menu_pic5.1fa8f20f.png";